const e = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>End Expression Icon</title><desc>A picture showing three dots followed by a right-pointed chevron.</desc><path d="M13.14 6.76L17.49 12l-4.35 5.24 1.54 1.28L20.09 12l-5.41-6.52-1.54 1.28z"/><path d="M11.91 11h2v2h-2zm-4 0h2v2h-2zm-4 0h2v2h-2z"/></svg>';
export {
  e as default
};
